import { render, staticRenderFns } from "./form-data.vue?vue&type=template&id=d5ce4a08&"
import script from "./form-data.vue?vue&type=script&lang=js&"
export * from "./form-data.vue?vue&type=script&lang=js&"
import style0 from "./form-data.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports